document.addEventListener('change', function(event) {
  if (event.target.classList.contains('hc-variants')) {
    var hc_product = event.target.getAttribute('data-product');
    var hc_value = event.target.value;
    var hc_trigger = document.querySelector('.hc-trigger[data-product="'+hc_product+'"]');
    if (hc_trigger) {
      hc_trigger.setAttribute('data-variant', hc_value);
    }
  }
});

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('hc-trigger')) {
    event.preventDefault();
    var hc_id = parseInt(event.target.getAttribute('data-variant'));
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        alert(JSON.parse(xhr.responseText).untranslated_product_title + ' ' + JSON.parse(xhr.responseText).untranslated_variant_title + ' has been succesfully added to cart!');
        fetch('/cart.js').then(res => res.json()).then(cart => {
          document.querySelector('.site-header-cart--count').setAttribute('data-header-cart-count', cart.item_count);
        });
      } else {
        var response = JSON.parse(xhr.responseText);
        alert(response.description);
      }
    };
    xhr.onerror = function() {
      alert('Request failed');
    };
    xhr.send('quantity=1&id='+hc_id);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const hc_accordions = document.querySelectorAll('.hc-button');
  hc_accordions.forEach(function(hc_accordion) {
    hc_accordion.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      hc_accordion.parentNode.classList.toggle('hc-active');
    });
  });
});